import './styles/vendor/main.vendor.scss';
import './styles/main.scss';
import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import ReduxModal, { modal } from 'react-redux-modal';
import 'react-image-lightbox/style.css';
import 'react-datepicker/dist/react-datepicker.css';
import WindowResizeListener from './utils/WindowResizeListener';

import {
  Header,
  Footer,
  SideNav,
  ComingSoonModal,
  FeedbackModal,
  ChannelList,
  SnapshotBackground,
  Metadata,
  Scroller
} from './components';

import {
  isMobile,
  BACKGROUND_COLOR,
  BACKGROUND_WHITE,
  BACKGROUND_GREY
} from './utils';

import { setPreviousPath, setInitialLoad } from './actions/globalConfig';
import ServerError from './components/InitialLoad/ServerError';

const propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
  children: PropTypes.shape().isRequired,
  dispatch: PropTypes.func.isRequired,
  pathName: PropTypes.string.isRequired,
};

class App extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      headerHeight: null
    }
    this.onComingSoon = this.onComingSoon.bind(this);
    this.onFeedback = this.onFeedback.bind(this);
  }

  componentDidMount() {
    if(this.props.backgroundChoice === BACKGROUND_WHITE) {
      $('body').removeClass('main-grey-bkg').addClass('main-white-bkg');
    } else {
      $('body').removeClass('main-white-bkg').addClass('main-grey-bkg');
    }
    this._handleResize();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.location !== this.props.location) {
      if (this.props.initialLoad) {
        this.props.dispatch(setInitialLoad(false));
      }
      if (this.props.location.pathname.includes('/livecams')) {
        this.props.dispatch(setPreviousPath(this.props.location.pathname));
      }
    }

    if(nextProps.backgroundChoice === BACKGROUND_WHITE) {
      $('body').removeClass('main-grey-bkg').addClass('main-white-bkg');
    } else {
      $('body').removeClass('main-white-bkg').addClass('main-grey-bkg');
    }
  }

  componentDidUpdate(prevProps) {
    const wasLivecamRoute = prevProps.children.props.route.livecam;
    const isLivecamRoute = this.props.children.props.route.livecam;
    if (wasLivecamRoute !== isLivecamRoute) {
      this._handleResize();
    }
  }

  _handleResize = () => this.setState({ headerHeight: this.header.getBoundingClientRect().height })

  onComingSoon(e) {
    if (e) {
      e.preventDefault();
    }
    modal.add(ComingSoonModal, { title: '', size: 'medium', hideTitleBar: true })
  }

  onFeedback (e) {
    if (e) {
      e.preventDefault();
    }
    modal.add(FeedbackModal, {size:'medium', hideTitleBar: true});
  }

  render() {
    const homeClass = classNames({
      active: this.props.pathName === '/',
    });
    const protectedClass = classNames({
      active: this.props.pathName === '/protected',
    });
    const loginClass = classNames({
      active: this.props.pathName === '/login',
    });

    const isPhotos = this.props.pathName.match(/photos\/.*/gm);

    const { backgroundChoice, serverError } = this.props;
    const showSnapshotBkg = backgroundChoice === BACKGROUND_COLOR;
    const isLivecamRoute = this.props.children.props.route.livecam;
    const isStaticPageRoute = this.props.children.props.route.staticPage;
    const scrollerSelector = isStaticPageRoute ? '.static-page-top-block' : '.livecams .video-player';
    const wrapperClass = (isLivecamRoute) ? ' has-channel-nav' : '';
    const mobileClass = (!isMobile.any) ? ' is-desktop' : '';
    return (
      <div className={`app ${isPhotos ? 'photo-gallery' : ''}`}>
        <div className={`site-wrapper${wrapperClass}${mobileClass}`}>

          { !isMobile.any && isLivecamRoute &&
            <div className="feedback-tab d-none d-xl-block" onClick={this.onFeedback}>Feedback</div>
          }
          { this.props.pathName === '/help' &&
            <a href="https://files.explore.org/files/Explore_Website_Handbook.pdf" target="_blank">
              <div className="help-tab">Explore Website Handbook PDF</div>
            </a>
          }

          {isLivecamRoute && showSnapshotBkg && <SnapshotBackground img={this.props.backgroundImage} />}
          <div
            className="header-wrapper"
            ref={ (node) => this.header = node }
          >
            <div className="background-container d-none d-sm-block">
            {isLivecamRoute && showSnapshotBkg && <SnapshotBackground img={this.props.backgroundImage} />}
            </div>
            <Header comingSoon={this.onComingSoon} ref='header' opaqueBg={(isLivecamRoute) ? false : true}/>
            {isLivecamRoute && <ChannelList />}
          </div>
          <WindowResizeListener onResize={this._handleResize} />
          <div className="main-wrapper" style={{ marginTop: this.state.headerHeight }}>
            <div className="main-content">
              {this.props.children}
            </div>
            <Footer comingSoon={this.onComingSoon}/>
          </div>
        </div>
        <div className="side-nav-wrapper">
          <SideNav />
        </div>
        {(isLivecamRoute || isStaticPageRoute) ? <Scroller scrollerSelector={scrollerSelector} /> : serverError ? <ServerError error={serverError} /> : null}
        <ReduxModal />
        <Metadata />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  let backgroundImage = state.globalConfig.backgroundImage;
  backgroundImage = backgroundImage.replace('http://files', 'https://files');
  return {
    isAuthenticated: state.auth.isAuthenticated,
    pathName: ownProps.location.pathname,
    previousPath: state.globalConfig.previousPath,
    initialLoad: state.globalConfig.initialLoad,
    backgroundImage,
    backgroundChoice: state.uiPreferences.backgroundChoice,
    serverError: state.globalConfig.serverError,
  };
};

App.propTypes = propTypes;

export default connect(mapStateToProps)(App);
